export class StorageWorker {
  public storage: any;
  public isAvailable: boolean;

  constructor(storage) {
    this.storage = storage;
    this.isAvailable = this.isStorageWork();
  }

  public clear() {
    this.storage.clear();
  }

  public isStorageWork() {
    let res = true;

    try {
      this.storage.setItem('test', 'test');
    } catch (e) {
      res = false;
    }

    return res;
  }

  public saveAsJson(key, obj) {
    if (!this.isAvailable) {
      return '';
    }

    const json = JSON.stringify(obj);
    this.storage.setItem(key, json);
  }

  getAsJson(key) {
    if (!this.isAvailable) {
      return {};
    }

    const json = this.storage.getItem(key);
    return JSON.parse(json);
  }

  save(key, str) {
    if (!this.isAvailable) {
      return;
    }

    this.storage.setItem(key, str);
  }

  get(key) {
    if (!this.isAvailable) {
      return undefined;
    }

    const str = this.storage.getItem(key);
    return str;
  }

  remove(key) {
    if (!this.isAvailable) {
      return;
    }

    this.storage.removeItem(key);
  }
}
